import React from 'react';
import { ProgramsPage as Page } from '@sandtech-hub-monorepo/ui-kit-site';
import { AppRoutesPaths } from '../../routes/types';

export const ProgramsPage = () => (
  <Page
    learningPageLink={AppRoutesPaths.Learning}
    programPageLink={AppRoutesPaths.Program}
    paymentBanner={false}
  />
);
